export default "__VITE_ASSET__CACtZ0d$__"